import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isRefreshing"];
import { GridList } from 'breeze-intelligence-kit';
import { EnrichmentAvailableListHeader } from './EnrichmentAvailableListHeader';
import { EnrichmentAvailableListHeaderItem } from './EnrichmentAvailableListHeaderItem';
import { EnrichmentAvailableListBody } from './EnrichmentAvailableListBody';
import { EnrichmentAvailableListRow } from './EnrichmentAvailableListRow';
import { EnrichmentAvailableListItem } from './EnrichmentAvailableListItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrichmentAvailableList = _ref => {
  let {
      children,
      isRefreshing = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(GridList, Object.assign({
    isRefreshing: isRefreshing
  }, rest, {
    children: children
  }));
};
EnrichmentAvailableList.Header = EnrichmentAvailableListHeader;
EnrichmentAvailableList.HeaderItem = EnrichmentAvailableListHeaderItem;
EnrichmentAvailableList.Body = EnrichmentAvailableListBody;
EnrichmentAvailableList.Row = EnrichmentAvailableListRow;
EnrichmentAvailableList.Item = EnrichmentAvailableListItem;